import { required, optional } from 'AppReact/schema';

export default {
  isVisible: required('boolean'),
  unitId: optional('integer'),
  moveOutDate: optional('jsDate'),
  moveInDate: optional('jsDate'),
  readyDate: optional('jsDate'),

  unitIdError: optional('string'),
  createError: optional('string'),
}

export const defaultNewCardModal = {
  isVisible: false,
  unitId: [],
  moveOutDate: null,
  moveInDate: null,
  readyDate: null,

  unitIdError: null,
  cardError: null
}